// extracted by mini-css-extract-plugin
export default {"wrapper":"OfertasFilters_wrapper__eBf2s","content":"OfertasFilters_content__SaE7L"};